import DatabaseModel from './DatabaseModel.js';

// #934 · Resultado, motivo y siguiente paso de una tarea de llamada (fase 0 del protocolo de
// llamadas: se anota, no se graba). Vive en el CRM y no en la tarea, así que va por su propio
// endpoint; la tarea se sigue guardando por el suyo de siempre.
const LlamadaAnotacion = Object.create(DatabaseModel);

LlamadaAnotacion.model = 'api/crm/llamadas';

// Listas en uso, tipos de llamada y, si la hay, la anotación de esta tarea.
LlamadaAnotacion.deTarea = function(idTarea) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/tarea/' + encodeURIComponent(idTarea),
        method: 'GET',
        data: {}
    }, false);
};

// data = { resultado, motivo, siguientePaso } (códigos de las listas)
LlamadaAnotacion.guardar = function(idTarea, data) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/tarea/' + encodeURIComponent(idTarea),
        method: 'PUT',
        data: data
    }, false);
};

export default LlamadaAnotacion;
